import { render, staticRenderFns } from "./price-aggreement-add-or-update.vue?vue&type=template&id=fbc1426e&scoped=true"
import script from "./price-aggreement-add-or-update.vue?vue&type=script&lang=js"
export * from "./price-aggreement-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./price-aggreement-add-or-update.vue?vue&type=style&index=0&id=fbc1426e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc1426e",
  null
  
)

export default component.exports